const defaultState = {
  isSet: false,
};

const permissionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PERMISSIONS':
      return {
        ...action.data,
        isSet: true,
      };

    default:
      return state;
  }
};

export default permissionsReducer;
